import ApiService from "@Src/services/ApiService";
import { TOPIC_ANALYTICS_API_ROUTES } from "./skillwise-analytics.api.constant";

export async function getSkillAnalysis(params?: any): Promise<any> {
    return await ApiService.fetchData({
        url: TOPIC_ANALYTICS_API_ROUTES.SKILL_ANALYSIS,
        method: "get",
        params: params
    });
}
